import React from 'react'
import { useSelector } from 'react-redux'
import Resx from '@/components/Resx'
import { Main, MainTop, MainTopTitle, MainBody } from '@/components/Layout'
import { BsrsGrid, Column, EnumFilterCell, EnumCellStatus, commandColumnProps, DateFilterCell, DateTimeFilterCell, DateTimeCell, DueDateCell } from '@/components/BsrsGrid'
import { workflowTaskStatus } from '@/enums/workflowTaskStatus'
import { useLocalization } from '@/hooks/localization'
import context from '@/context'
import NameColumn from '@/components/BsrsGrid/BsrsGrid.NameColumn'

// The original dataSource was: context.api.taskService.getMyTasks
const TasksList = React.memo(function TaskList ({ isAllTasks }) {
  const { localize, localizeProps, locale } = useLocalization()
  const gridKey = useSelector(state => state.myTasks.gridKey)

  return <Main>
    <MainTop>
      <MainTopTitle>
        <Resx name={isAllTasks ? 'Tasks.AllTasksTitle' : 'Tasks.MyTasksTitle'} />
      </MainTopTitle>
    </MainTop>
    <MainBody>
      <BsrsGrid
        persistenceId={isAllTasks ? 'all-tasks' : 'my-tasks'}
        lastReloadedAt={gridKey}
        dataSource={isAllTasks ? context.api.taskService.getAllTasks : context.api.taskService.getMyTasks}
        defaultSort={[{ field: 'id', dir: 'desc' }]}>
        <Column field='id' title={localize('Common.Id')} filter='numeric' width='150px' />
        <Column field='assignedTo' title={localize('Tasks.AssignedTo')} />
        {NameColumn({ nameProp: 'ticketName', latinNameProp: 'ticketLatinName', locale, title: localize('Tickets.TicketName'), editable: false })}
        <Column field={localizeProps()} title={localize('Tasks.Task')} />
        <Column field='dueDate' title={localize('Tasks.DueDate')} filter='date' cell={DueDateCell} filterCell={DateFilterCell} />
        <Column field='status' title={localize('Tasks.Status')}
          cell={EnumCellStatus({ localize, enumName: workflowTaskStatus.enumName })}
          filterCell={EnumFilterCell({ localize, enumName: workflowTaskStatus.enumName }, [0, 1, 2])}
          enumName={workflowTaskStatus.enumName} />
        <Column field='startTime' title={localize('Tasks.StartDate')} filter='date' cell={DateTimeCell} filterCell={DateTimeFilterCell} />
        <Column field='finishTime' title={localize('Tasks.FinishDate')} filter='date' cell={DateTimeCell} filterCell={DateTimeFilterCell} />
        <Column {...commandColumnProps({ detailUrl: x => x.canSeeDetail ? (isAllTasks ? `/all-tasks/${x.id}` : `/tasks/${x.id}`) : '' })} />
      </BsrsGrid>
    </MainBody>
  </Main>
})

export {
  TasksList
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/tasks/list.js